import type { CSSProperties, MouseEvent } from 'react'
import { Component } from 'react'

import { type TableCellProps } from '@material-ui/core/TableCell'

import { TableCellStyled } from './styles/TableCellStyled'
import { IconChevronDown, IconChevronUp } from '../../elements/Icon'

export interface ITableCellProps extends TableCellProps {
  orderBy?: string
  width?: CSSProperties['width']
  minWidth?: CSSProperties['minWidth']
  maxWidth?: CSSProperties['maxWidth']
  stickyRight?: boolean
  /**
   * Distance (in px) from the right edge for a sticky-right cell. Only applied
   * when `stickyRight` is true. Defaults to 0 (flush right). Used to pin
   * multiple columns side-by-side, each offset by the widths of the sticky
   * columns to its right.
   */
  stickyRightOffset?: number
  nowrap?: boolean
  onClick?(e: MouseEvent<HTMLElement>): void
}

export class TableCell extends Component<ITableCellProps> {
  static defaultProps = {
    orderBy: null,
    width: 'auto',
  }

  render() {
    const { onClick, orderBy, ...otherProps } = this.props
    return (
      <TableCellStyled className='table-cell' onClick={onClick} {...otherProps}>
        {this.props.children}
        {orderBy &&
          (orderBy === 'asc' ? (
            <IconChevronDown
              className='table-cell-order-by-icon'
              style={{ float: 'right' }}
            />
          ) : (
            <IconChevronUp
              className='table-cell-order-by-icon'
              style={{ float: 'right' }}
            />
          ))}
      </TableCellStyled>
    )
  }
}
